import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { UrlIdResolverService } from '../../../shared/services/url-id-resolver.service';
import { DocumentsService } from '../../../../state/document.service';
import {
  DocumentsRepository,
  IDocument,
} from '../../../../state/document.repository';
import { TrackRender } from 'app/shared/front-perfomance';
import { BreadcrumbService } from 'app/modules/shared/components/breadcrumb/breadcrumb.service';

@TrackRender()
@Component({
    selector: 'app-document-editpage',
    templateUrl: './document-editpage.component.html',
    styleUrls: ['./document-editpage.component.scss'],
    standalone: false
})
export class DocumentEditpageComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private repo: DocumentsRepository,
    private service: DocumentsService,
    private location: Location,
    private urlId: UrlIdResolverService,
    private breadcrumbService: BreadcrumbService
  ) {}

  id!: string;
  document: IDocument | null = null;
  ngOnInit(): void {
    this.route.paramMap.subscribe({
      next: (value) => {
        this.id = value.get('id')!;
        this.breadcrumbService.setDynamicLabel('documentTitle', 'editDocument');
        this.service.loadOneDocument(`${value.get('id')}`).subscribe((x) => {
          this.document = x;
          this.breadcrumbService.setDynamicLabel(
            'documentTitle',
            x?.title || 'editDocument',
          );
        });
      },
    });
  }
}
